
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/books/team-topologies",
      function () {
        return require("private-next-pages/books/team-topologies.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/books/team-topologies"])
      });
    }
  